import { LastMessage } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => () =>
  makeCall<LastMessage>('GET', `/api/v2/conversations/last-message`);
